var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.4999C9.47276 10.4999 10.6667 9.30601 10.6667 7.83325C10.6667 6.36049 9.47276 5.16659 8 5.16659C6.52724 5.16659 5.33333 6.36049 5.33333 7.83325C5.33333 9.30601 6.52724 10.4999 8 10.4999ZM8 9.16659C7.26362 9.16659 6.66667 8.56963 6.66667 7.83325C6.66667 7.09687 7.26362 6.49992 8 6.49992C8.73638 6.49992 9.33333 7.09687 9.33333 7.83325C9.33333 8.56963 8.73638 9.16659 8 9.16659Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.74662C2 4.47829 4.68871 1.83325 8 1.83325C11.3113 1.83325 14 4.47829 14 7.74662C14 9.36102 13.3396 10.873 12.1967 11.9728L8.46756 15.6418C8.20812 15.8971 7.79192 15.8971 7.53247 15.6418L3.79823 11.9682C2.65629 10.8638 2 9.35603 2 7.74662ZM11.2669 11.0172C12.1571 10.1605 12.6667 8.99384 12.6667 7.74662C12.6667 5.2196 10.5798 3.16659 8 3.16659C5.42025 3.16659 3.33333 5.2196 3.33333 7.74662C3.33333 8.99002 3.83976 10.1535 4.72922 11.0137L7.99997 14.2314L11.2669 11.0172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.9771e5c2aea8bdd51d3039d33b85c5a0.svg";
export { ForwardRef as ReactComponent };